export { default as Faq } from './Faq';
export { default as Main } from './Main';
export { default as Plans } from './Plans';
export { default as Support } from './Support';
export { default as PricingCompareTable } from './PricingCompareTable';
